<template>
  <BaseEmptyState class="empty-state-icon-alt w-full bg-whiteOverride">
    <template v-slot:icon>
      <div>
        <EnvelopesIcon/>
      </div>
    </template>
    <template v-slot:title>
      <h2 class="text-center">{{ $t('ui.envelopes.emptyState.noAssociatedEnvelopes.title') }}</h2>
    </template>
    <template v-slot:content>
      <p class="text-center">{{ $t('ui.envelopes.emptyState.noAssociatedEnvelopes.info') }}</p>
      <ButtonLink
        :to="featureEnabled('new-envelope-flow') ? { name: 'EnvelopesCreate' } : { name: 'EnvelopeInstantiate' }"
        class="mx-auto"
        data-test="envelopes-button-text"
      >
        {{ $t('ui.envelopes.emptyState.noAssociatedEnvelopes.link') }}
      </ButtonLink>
    </template>
  </BaseEmptyState>
</template>

<script>
import { useGetters } from 'vuex-composition-helpers/dist';
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import { EnvelopesIcon } from '@/components/icons/svgIcons/EnvelopesIcon';

export default {
  name: 'NoAssociatedEnvelopesEmptyState',
  components: {
    BaseEmptyState,
    ButtonLink,
    EnvelopesIcon,
  },
  setup() {
    const { featureEnabled } = useGetters({ featureEnabled: 'featureFlags/featureEnabled' });

    return {
      featureEnabled,
    };
  },
};
</script>

<style scoped>
.empty-state-icon svg {
  @apply h-eightyEight w-eightyEight;
}
.empty-state-content h2 {
  @apply max-w-xl;
}
.empty-state-content p {
  @apply text-16 max-w-xl;
}
</style>
